import { render, staticRenderFns } from "./addEdit.vue?vue&type=template&id=454002d6&scoped=true"
import script from "./addEdit.vue?vue&type=script&lang=js"
export * from "./addEdit.vue?vue&type=script&lang=js"
import style0 from "./addEdit.vue?vue&type=style&index=0&id=454002d6&prod&lang=scss&scoped=true"
import style1 from "./addEdit.vue?vue&type=style&index=1&id=454002d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454002d6",
  null
  
)

export default component.exports